//本人証明用ページURLと確認用パスワード発行 /personIdentification/:cid
import React, {Component} from 'react';
import Header from './header'
import Footer from './footer'
import users from './store/user'
import './css/personIdentification.css';
import {Link,browserHistory} from 'react-router'
//import firebase from 'firebase'
import {onLogin, getCertificationCodes/*, registCertificationCode, deleteCertificationCode*/} from './firebase'

import Clipboard from 'react-clipboard.js';

import './css/toast_custom.css';
import Toast from './components/toast'

export default class App extends Component {

  constructor() {
    super();
    this.state = {
      myURL:"https://" + decodeURIComponent(window.location.hostname),
      code:"",
      expiration_dt:"",
      uid:"",
      cid:"",

      copyText:"",
      
      success_msg_text:""
    }
  }

  componentDidMount() {

    // URLにIDが付与されている場合
    let path = window.location.pathname;
    let path_arr = path.split("/");
    var cid = "";
    if ("" !== path_arr[2] && null !== path_arr[2] && "undefined" !== typeof path_arr[2]) {
      cid = path_arr[2];
    } else {
      // err
      browserHistory.push("/personIdentification1/");
    }

    this.setState({cid: cid});
    
    var scope = this
    
    // ログインチェック
    onLogin(function(){

      var uid = users.getMyUser().uid
      let displayName = users.getMyUser().displayName
      scope.setState({uid: uid});

      //console.log(uid,cid);

      getCertificationCodes(uid, function(value){
        for (var n in value) {
          if (Number(cid) === value[n].cid) {
            scope.setState({code: value[n].certificationCode});
            let arr = value[n].created_at.split(/[- :]/)
            let timestamp = Date.parse(new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]))
            //let timestamp = new Date(value[n].created_at).getTime();
            //timestamp += 1000 * 60 * 60 * 24;
            let cd = new Date(timestamp + 1000 * 60 * 60 * 24); 
            let expiration_dt = cd.getFullYear() + "年" + ("0"+(cd.getMonth()+1)).slice(-2)  + "月" + ("0"+cd.getDate()).slice(-2) + "日" + ("0"+cd.getHours()).slice(-2) + "時" + ("0"+cd.getMinutes()).slice(-2) + "分";
            //console.log(expiration_dt);
            scope.setState({expiration_dt: expiration_dt});

            let copyText = `【${displayName}】さんのMyRateを確認しましょう！

以下のURLで、【${displayName}】さんの信用情報を確認できます。
他人の信用情報を悪用するなりすましを防止するために、【${displayName}】さん本人しか発行できない暗証番号を用いて認証を行います。

URL：${scope.state.myURL + "/auth/" + scope.state.uid + "/" + scope.state.cid}
認証番号：${scope.state.code}

有効期限：${scope.state.expiration_dt}まで`
            scope.setState({copyText: copyText})

            break;
          }
        }
      });

    });


    //console.log(url_id);
  }

  onSuccess = () => {
    let success_msg_text = (<div className="toast-success"><p>コピーしました</p></div>)
    this.setState({success_msg_text:success_msg_text})
  }

  returnToast = () => {
    const {
      success_msg_text
    } = this.state
    if(success_msg_text) {
      return (
        <Toast notifyMessage={success_msg_text} />
      )
    }
  }

  render() {
      return (
    <div>
    <div id="wrapper">
      { this.returnToast() }
      <div id="" className="wrapper-lp wrapper-personIdentification">
        <Header/>
        <div className="webWrap">
          <div className="wrapCover">
            <div className="wrapCover__contentBlock clearfix">
              <div className="content-top">
                <div className="block-personIdentification">
                  <h2 className="title">Personal Identification</h2>
                  <p className="subtitle">新しく発行しました</p>
                  <p className="notice">コピーして相手に共有しましょう。</p>

                  <div className="text-copy" style={{whiteSpace:'pre-wrap',wordBreak:'break-all'}}>
                    {this.state.copyText}
                  </div>
                  <Clipboard component="a" className="btn-copy" data-clipboard-text={this.state.copyText} onSuccess={this.onSuccess}>テキストをコピーする</Clipboard>
                </div>
                <Link to="/personIdentification1" className="btn-resend">再発行する</Link>
                <div className="block-notification">
                  <p>※確認用パスワードは発行してから24時間有効です</p>
                  <p>※共有したい相手が複数人いる場合は、人数分都度発行してください。</p>
                </div>
              </div>
            </div>
            <Footer/>
          </div>
        </div>
      </div>
    </div>
    </div>
      )

    }
}



// WEBPACK FOOTER //
// ./src/personIdentification.js